import React, { useState, useEffect } from 'react';

import { Form, Button, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FaDownload, FaEye } from 'react-icons/fa';

import * as yup from 'yup';
import { Formik, Field } from 'formik';
import ReactQuill from 'react-quill';

import AppService from 'Services/AppService';
import { getMediaUrl } from 'Utils/Helpers';

const schema = yup.object({
    appId: yup.string().required(),
    name: yup.string().required(),
    content: yup.string().min(3).required(),
});

import DocumentationService from 'Services/DocumentationService';

const Apps = (props) => {
    const history = useHistory();
    const [apps, setApps] = useState([]);
    const [documentation, setDocumentation] = useState(null);
    // const { register, handleSubmit, errors } = useForm();

    const {
        match: { params },
    } = props;

    useEffect(() => {
        AppService.getApps()
            .then((result) => {
                if (result.status === 200) {
                    setApps(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

        if (params.documentationId) {
            DocumentationService.getDocumentationById(params.documentationId)
                .then((result) => {
                    if (result.status === 200) {
                        setDocumentation(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params]);

    const submitForm = (data) => {
        DocumentationService.saveDocumentation(data, params.documentationId)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/documentation/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/documentation/index' }}>
                    Documentations
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    {params.documentationId ? 'Edit Documentation' : 'Create New Documentation'}
                </Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">
                        {params.documentationId ? 'Edit Documentation' : 'Create New Documentation'}
                    </h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.documentationId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            name: documentation ? documentation.name : '',
                            appId: documentation ? documentation.appId : '',
                            content: documentation ? documentation.content : '',
                            file: null,
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="name"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea99">
                                    <Form.Label>App</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="appId"
                                        value={values.appId}
                                        onChange={handleChange}
                                        isInvalid={!!errors.appId}
                                    >
                                        <option value="">-</option>
                                        {apps.map((app, key) => {
                                            return (
                                                <option value={app.appId} key={key}>
                                                    {app.name}
                                                </option>
                                            );
                                        })}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{errors.appId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCControlox">
                                    <Form.Label>Content</Form.Label>
                                    <Field name="content">
                                        {({ field }) => (
                                            <ReactQuill
                                                theme="snow"
                                                value={field.value}
                                                onChange={field.onChange(field.name)}
                                            />
                                        )}
                                    </Field>
                                    <Form.Control.Feedback type="invalid">{errors.content}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formFile" className="mb-3">
                                    <Form.Label>Fichier joint (PDF, image…)</Form.Label>
                                    {documentation?.fileUrl && (
                                        <div className="mb-2">
                                            <a
                                                href={getMediaUrl(documentation.fileUrl)}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-sm btn-outline-secondary me-2"
                                            >
                                                <FaEye className="me-1" /> Voir le fichier actuel
                                            </a>
                                            <a
                                                href={getMediaUrl(documentation.fileUrl)}
                                                download
                                                target="_blank"
                                                rel="noreferrer"
                                                className="btn btn-sm btn-outline-primary"
                                            >
                                                <FaDownload className="me-1" /> Télécharger
                                            </a>
                                        </div>
                                    )}
                                    <Form.Control
                                        id="doc-file-input"
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        onChange={(e) => setFieldValue('file', e.currentTarget.files[0] || null)}
                                    />
                                    <Form.Text className="text-muted">
                                        Laisser vide pour conserver le fichier existant.
                                    </Form.Text>
                                </Form.Group>
                                <Button variant="primary" type="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        )}
                    </Formik>
                    {/* {errors.exampleRequired && <span>This field is required</span>}

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>App</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="App"
                                name="AppId"
                                defaultValue={documentation ? documentation.appId : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Name"
                                name="Name"
                                defaultValue={documentation ? documentation.name : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Content</Form.Label>
                            <Form.Control as="textarea" rows={3} />
                        </Form.Group>
                        <Button variant="primary" type="submit" block>
                            Submit
                        </Button>
                    </Form> */}
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
